// MakeOrderPage.jsx
// MakeOrderPage.jsx
"use client"

import { useState, useEffect } from 'react'
import { FaPlus, FaSave, FaSpinner, FaArrowLeft } from 'react-icons/fa'
import { getDatabase, ref, push, set } from 'firebase/database';


export default function MakeOrderPage({
  codes = [],                // all codes of selected user
  selectedUser = {},         // contains companyName etc
  userId = '',
  initialSiteKey = null,
  onBack,
  onSubmitOrder,
}) {
  const [selectedCodeId, setSelectedCodeId] = useState('')
  const [selectedSiteKey, setSelectedSiteKey] = useState('')

  const [formData, setFormData] = useState({
    brand: '',
    code: '',
    companyName: selectedUser?.company_name || selectedUser?.companyName || '',
    existingBalance: '',
    grade: 'OPC 43',           // default
    paymentAmount: '',
    paymentMethod: 'utr',      // default
    utrNumber: '',
    quantity: '',
    quantityType: 'Bags',      // default
    rate: '',
    siteAddress: {
      address: '',
      state: '',
      pincode: '',
    },
    usingExistingBalance: false,
    poFile: null,              // file upload
    paymentFile: null,         // file upload
  })
  useEffect(() => {
    if (selectedUser) {
      setFormData(prev => ({
        ...prev,
        companyName: selectedUser.company_name || selectedUser.companyName || ''
      }))
    }
  }, [selectedUser])

  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({})

  const [showOrderForm, setShowOrderForm] = useState(false)
  const [successMsg, setSuccessMsg] = useState("")

  const [userCodes, setUserCodes] = useState([])
  const [codesLoading, setCodesLoading] = useState(true)

  useEffect(() => {
    if (Array.isArray(codes) && codes.length > 0) {
      setUserCodes(codes)
    } else {
      setUserCodes([])
    }
    setCodesLoading(false)
  }, [codes])

  // Auto-fill brand, code, companyName, balance when code is selected
  useEffect(() => {
    if (!selectedCodeId) return
    const codeObj = userCodes.find(c => c.id === selectedCodeId)
    if (!codeObj) return

    setFormData(prev => ({
      ...prev,
      brand: codeObj.brand || '',
      code: codeObj.codeID || '',
      companyName: selectedUser.companyName || selectedUser.company_name || '',
      existingBalance: codeObj.balance || 0,
    }))

    setSelectedSiteKey('')
  }, [selectedCodeId, userCodes, selectedUser])

  // When site is selected → auto-fill address
  useEffect(() => {
    if (!selectedCodeId || !selectedSiteKey) return

    const codeObj = userCodes.find(c => c.id === selectedCodeId || c.codeID === selectedCodeId)
    if (!codeObj?.sites?.[selectedSiteKey]) return

    const site = codeObj.sites[selectedSiteKey]

    setFormData(prev => ({
      ...prev,
      siteAddress: {
        address: site.address || '',
        state: site.state || '',
        pincode: site.pincode || '',
      }
    }))
  }, [selectedSiteKey, selectedCodeId, userCodes])

  // (Removed useEffect for sites prop)

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    const val = type === 'checkbox' ? checked : value

    if (name.includes('siteAddress.')) {
      const field = name.split('.')[1]
      setFormData(prev => ({
        ...prev,
        siteAddress: {
          ...prev.siteAddress,
          [field]: val
        }
      }))
    } else {
      setFormData(prev => ({ ...prev, [name]: val }))
    }

    // Clear error
    setErrors(prev => ({ ...prev, [name]: '' }))
  }

  const handleFileChange = (e, field) => {
    const file = e.target.files[0]
    if (file) {
      setFormData(prev => ({ ...prev, [field]: file }))
    }
  }

  const validateForm = () => {
    const newErrors = {}
    if (!selectedCodeId) newErrors.code = 'Please select a code'
    if (!selectedSiteKey) newErrors.site = 'Please select a site'
    if (!formData.quantity || isNaN(formData.quantity) || Number(formData.quantity) <= 0) {
      newErrors.quantity = 'Valid quantity required'
    }
    if (!formData.paymentAmount || isNaN(formData.paymentAmount) || Number(formData.paymentAmount) <= 0) {
      newErrors.paymentAmount = 'Valid payment amount required'
    }
    // Add more validations as needed

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validateForm()) return

    setLoading(true)

    const orderData = {
      brand: formData.brand,
      code: formData.code,
      companyName: formData.companyName,
      existingBalance: Number(formData.existingBalance) || 0,
      grade: formData.grade,
      paymentAmount: Number(formData.paymentAmount),
      paymentFileUrl: "", // upload later
      paymentMethod: formData.paymentMethod,
      payment_status: "pending",
      poFileUrl: "", // upload later
      quantity: Number(formData.quantity),
      quantityType: formData.quantityType,
      rate: formData.rate || "",
      siteAddress: { ...formData.siteAddress },
      status: "Pending",
      statusUpdatedAt: new Date().toISOString(),
      timestamp: new Date().toISOString(),
      usingExistingBalance: formData.usingExistingBalance,
      utrNumber: formData.utrNumber || "",
    }

    try {
      if (!selectedUser?.uid) {
        alert("Please select a valid user before submitting order");
        setLoading(false);
        return;
      }

      const db = getDatabase();
      const ordersRef = ref(db, `orders/${selectedUser.uid}`); // store under user ID
      const newOrderRef = push(ordersRef);
      await set(newOrderRef, orderData);
// Already declared above
// const db = getDatabase();

const codeRef = ref(db, `new-code/${selectedUser.uid}/codes`);
const { get, child } = await import('firebase/database');
const codesSnap = await get(codeRef);
if (codesSnap.exists()) {
  const codesData = codesSnap.val();
  const codeEntry = Object.entries(codesData).find(([key, val]) => val.codeID === formData.code);
  if (codeEntry) {
    const [codeKey, codeValue] = codeEntry;
    const balanceRef = child(codeRef, `${codeKey}/balance`);
    const existingBalance = Number(codeValue.balance || 0);
    const newBalance = existingBalance + Number(formData.paymentAmount || 0);
    await set(balanceRef, newBalance);
  }
}

      setSuccessMsg("Order placed successfully!");
      setShowOrderForm(false);
      setTimeout(() => setSuccessMsg(''), 2000);
    } catch (err) {
      alert("Error creating order: " + err.message);
    } finally {
      setLoading(false);
    }
  }

  const selectedCode = userCodes.find(c => c.id === selectedCodeId)

  const renderCodeDetails = () => {
    if (!selectedCode) return <p className="text-gray-500">Select a code to view details</p>

    return (
      <div className="code-details-card">
        <div className="details-header">
          <h2>Code Details</h2>
          <button className="btn-primary" onClick={() => setShowOrderForm(true)}>Make Order</button>
        </div>
        <div className="details-grid">
          <div>
            <strong>Company:</strong> {selectedUser.company_name || selectedUser.companyName || '—'}
          </div>
          <div><strong>Code ID:</strong> {selectedCode.codeID}</div>
          <div><strong>Brand:</strong> {selectedCode.brand}</div>
          <div><strong>Balance:</strong> ₹{selectedCode.balance}</div>
        </div>
        <div className="sites-list">
          <h3>Sites</h3>
          {Object.values(selectedCode.sites || {}).map((s, i) => (
            <div key={i} className="site-item">{s.address}, {s.state} - {s.pincode}</div>
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className="order-page container mx-auto p-6 max-w-full flex gap-6">
      <div className="code-sidebar border rounded p-4 bg-white h-fit">
        <h2 className="text-lg font-semibold mb-3">User Codes</h2>
        <div className="space-y-2 max-h-[70vh] overflow-y-auto">
          {codesLoading && <div className="text-sm text-gray-500">Loading codes...</div>}
          {userCodes.map(code => (
            <div
              key={code.id}
              onClick={() => setSelectedCodeId(code.id)}
              className={`code-sidebar-card ${selectedCodeId === code.id ? 'active' : ''}`}
            >
              <div className="font-medium">{code.codeID}</div>
              <div className="text-sm text-gray-600">{code.brand}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="order-right-panel">
        {successMsg && <div className="success-msg">{successMsg}</div>}
        {!showOrderForm && renderCodeDetails()}
        {showOrderForm && (
          <>
            <div className="page-header-row" style={{ marginBottom: 12 }}>
              <h2 style={{ fontSize: '1.25rem', fontWeight: '500', margin: 0 }}>Place Order for Client</h2>
              <button type="button" onClick={() => setShowOrderForm(false)} className="btn-cancel">×</button>
            </div>
            <form onSubmit={handleSubmit} className="order-form">
              {/* Top section: Site selection card */}
              {selectedCode && (
                <div className="card p-4 w-full max-w-full mb-4">
                  <h2 className="text-lg font-semibold mb-3">Select Site Address</h2>
                  <select
                    value={selectedSiteKey}
                    onChange={e => setSelectedSiteKey(e.target.value)}
                    className={`form-control w-full ${errors.site ? 'border-red-500' : ''}`}
                    required
                  >
                    <option value="">-- Select Site --</option>
                    {Object.entries(selectedCode.sites || {}).map(([key, site]) => (
                      <option key={key} value={key}>
                        {site.address} {site.state && `(${site.state})`}
                      </option>
                    ))}
                  </select>
                  {errors.site && <p className="text-red-600 text-sm mt-1">{errors.site}</p>}
                  {/* Auto-filled site address */}
                  {selectedSiteKey && (
                    <div className="mt-3 p-3 bg-gray-50 rounded">
                      <p><strong>Address:</strong> {formData.siteAddress.address}</p>
                      <p><strong>State:</strong> {formData.siteAddress.state}</p>
                      <p><strong>Pincode:</strong> {formData.siteAddress.pincode || '—'}</p>
                    </div>
                  )}
                </div>
              )}
              {/* Bottom section: two columns */}
              <div className="order-form-flex">
                {/* Left column: fetched info */}
                <div className="form-left">
                  <div>
                    <label className="block mb-1">Brand</label>
                    <input type="text" value={formData.brand} readOnly className="form-control bg-gray-100" />
                  </div>
                  <div>
                    <label className="block mb-1">Code</label>
                    <input type="text" value={formData.code} readOnly className="form-control bg-gray-100" />
                  </div>
                  <div>
                    <label className="block mb-1">Company Name</label>
                    <input
                      type="text"
                      name="companyName"
                      value={formData.companyName}
                      readOnly
                      className="form-control bg-gray-100"
                    />
                  </div>
                  <div>
                    <label className="block mb-1">Existing Balance</label>
                    <input type="text" value={formData.existingBalance} readOnly className="form-control bg-gray-100" />
                  </div>
                </div>
                {/* Right column: fillable info */}
                <div className="form-right">
                  {/* First row: Grade, Quantity, Quantity Type */}
                  <div className="form-row-flex">
                    <div className="form-row-item">
                      <label className="block mb-1">Grade</label>
                      <select name="grade" value={formData.grade} onChange={handleChange} className="form-control">
                        <option value="OPC 43">OPC 43</option>
                        <option value="OPC 53">OPC 53</option>
                        <option value="PPC">PPC</option>
                        <option value="PSC">PSC</option>
                      </select>
                    </div>
                    <div className="form-row-item">
                      <label className="block mb-1">Quantity ({formData.quantityType})</label>
                      <input
                        type="number"
                        name="quantity"
                        value={formData.quantity}
                        onChange={handleChange}
                        className={`form-control ${errors.quantity ? 'border-red-500' : ''}`}
                        placeholder="e.g. 1200"
                        required
                      />
                      {errors.quantity && <p className="text-red-600 text-sm">{errors.quantity}</p>}
                    </div>
                    <div className="form-row-item">
                      <label className="block mb-1">Quantity Type</label>
                      <select name="quantityType" value={formData.quantityType} onChange={handleChange} className="form-control">
                        <option value="Bags">Bags</option>
                        <option value="Bulker">MT</option>
                      </select>
                    </div>
                  </div>
                  {/* Second row: Rate and Payment Amount */}
                  <div className="form-row-flex">
                    <div className="form-row-item form-row-item-wide">
                      <label className="block mb-1">Rate (₹ per bag/ton)</label>
                      <input
                        type="number"
                        name="rate"
                        value={formData.rate}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Optional"
                      />
                    </div>
                    <div className="form-row-item form-row-item-wide">
                      <label className="block mb-1">Payment Amount (₹)</label>
                      <input
                        type="number"
                        name="paymentAmount"
                        value={formData.paymentAmount}
                        onChange={handleChange}
                        className={`form-control ${errors.paymentAmount ? 'border-red-500' : ''}`}
                        required
                      />
                      {errors.paymentAmount && <p className="text-red-600 text-sm">{errors.paymentAmount}</p>}
                    </div>
                  </div>
                  {/* Using Existing Balance checkbox with border */}
                  <div className="existing-balance-box mt-2">
                    <input
                      type="checkbox"
                      name="usingExistingBalance"
                      checked={formData.usingExistingBalance}
                      onChange={handleChange}
                      className="h-5 w-5"
                    />
                    <label className="block mb-1" style={{ marginBottom: 0 }}>Using Existing Balance?</label>
                  </div>
                  <div className="flex justify-end mt-4">
                    <button
                      type="submit"
                      disabled={loading}
                      className="btn-submit flex items-center gap-2"
                    >
                      {loading ? <FaSpinner className="animate-spin" /> : null}
                      {loading ? 'Submitting...' : 'Submit'}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </>
        )}
      </div>
    <style jsx>{`
      .order-form-flex {
        display: flex;
        gap: 40px;
        flex-wrap: wrap;
        margin-top: 16px;
        width: 100%;
      }
      .form-left {
        flex: 1 1 260px;
        min-width: 260px;
        display: flex;
        flex-direction: column;
        gap: 16px;
      }
      .form-right {
        flex: 2 1 440px;
        min-width: 340px;
        max-width: 700px;
        display: flex;
        flex-direction: column;
        gap: 18px;
      }
      .form-row-flex {
        display: flex;
        gap: 16px;
        width: 100%;
        margin-bottom: 0;
      }
      .form-row-item {
        flex: 1 1 0;
        min-width: 0;
        display: flex;
        flex-direction: column;
      }
      .form-row-item-wide {
        flex: 1 1 50%;
      }
      .btn-submit { background:#16a34a; color:white; padding:10px 16px; border-radius:6px; font-weight:500; cursor:pointer; }
      .btn-submit:hover { background:#15803d; }
      .existing-balance-box {
        border:1px solid #d1d5db;
        padding:8px;
        border-radius:6px;
        display:flex;
        align-items:center;
        gap:8px;
      }
.order-page {
  background:#f4f6f9;
  align-items:flex-start;
}

.order-right-panel {
  background:#ffffff;
  padding:24px;
  border-radius:12px;
  box-shadow:0 4px 12px rgba(0,0,0,0.06);
  min-height:auto;
  height:auto;
}

.code-sidebar {
  width: 300px;
  min-width: 260px;
  max-width: 380px;
}
.code-sidebar-card {
  padding:12px 14px;
  border-radius:8px;
  border:1px solid #e5e7eb;
  margin-bottom:10px;
  cursor:pointer;
  transition:all 0.2s ease;
  background:#fff;
  position:relative;
}
.code-sidebar-card:hover {
  background:#f9fafb;
  border-color:#cbd5e1;
}
.code-sidebar-card.active {
  border-color:#2563eb;
  background:#eff6ff;
}
.code-sidebar-card::after {
  content:'→';
  float:right;
  font-size:18px;
  color:#888;
  font-weight:600;
  margin-left:12px;
  position:absolute;
  right:14px;
  top:50%;
  transform:translateY(-50%);
}

.code-details-card {
  background:#ffffff;
  padding:22px;
  border-radius:12px;
  box-shadow:0 3px 10px rgba(0,0,0,0.05);
  margin-bottom:20px;
}

.details-header {
  display:flex;
  justify-content:space-between;
  align-items:center;
  border-bottom:1px solid #e5e7eb;
  padding-bottom:8px;
  margin-bottom:12px;
}

.details-grid {
  display:grid;
  grid-template-columns:repeat(auto-fit,minmax(220px,1fr));
  gap:14px 24px;
  margin-bottom:18px;
}

.sites-list h3 {
  font-weight:600;
  margin-bottom:8px;
}

.site-item {
  background:#f1f5f9;
  padding:8px 12px;
  border-radius:6px;
  font-size:14px;
  margin-bottom:6px;
}

.page-header-row {
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin-bottom:18px;
}

.order-form {
  display:flex;
  flex-direction:column;
  gap:22px;
}

.card {
  background:#fff;
  border-radius:12px;
  box-shadow:0 2px 8px rgba(0,0,0,0.05);
  padding:20px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 18px 24px;
  width: 100%;
}

.form-control {
  width:100%;
  padding:10px 12px;
  border-radius:8px;
  border:1px solid #d1d5db;
}
  .btn-primary {
    background: #2563eb;
    color: #fff;
    border: none;
    border-radius: 6px;
    font-weight: 500;
    padding: 6px 10px;
    margin: 10px 20px 30px 40px;
    cursor: pointer;
    font-size: 1rem;
    transition: background 0.15s;
    min-width: 0;
  }
  .btn-primary:hover {
    background: #1d4ed8;
  }
  .btn-cancel {
    background: #ffffff;
    color: #dc2626;
    font-size: 20px;
    font-weight: bold;
    border: 1px solid #dc2626;
    border-radius: 6px;
    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

.success-msg {
  background:#dcfce7;
  color:#166534;
  padding:12px 16px;
  border-radius:8px;
  margin-bottom:18px;
  font-weight:500;
}
`}</style>
    </div>
  )
}